import API from '@/api/ResidentialTemplate'
import MixinFactory from '@/store/mixin'
const Mixin = MixinFactory('ResidentialTemplate')

const state = {
  ...Mixin.state,
}

const mutations = {
  ...Mixin.mutations,
}

const actions = {
  fetch: Mixin.actions.fetch(API.get),
  mutate: Mixin.actions.mutate(API.mutate),
  remove: Mixin.actions.remove(API.delete),
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
